var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0569 13.2243H26.9108C26.4441 13.2243 26.0002 13.4485 25.7257 13.8329L18.5324 23.8083L15.2743 19.2874C14.9998 18.9076 14.5605 18.6788 14.0892 18.6788H11.9431C11.6456 18.6788 11.4718 19.0174 11.6456 19.2599L17.3472 27.1671C17.4819 27.355 17.6594 27.5082 17.8652 27.6139C18.0709 27.7196 18.2988 27.7747 18.5301 27.7747C18.7613 27.7747 18.9893 27.7196 19.195 27.6139C19.4007 27.5082 19.5782 27.355 19.7129 27.1671L29.3498 13.8054C29.5282 13.5629 29.3543 13.2243 29.0569 13.2243Z",
    fill: "#2A304A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0C9.17924 0 0 9.17924 0 20.5C0 31.8208 9.17924 41 20.5 41C31.8208 41 41 31.8208 41 20.5C41 9.17924 31.8208 0 20.5 0ZM20.5 37.5223C11.1011 37.5223 3.47768 29.8989 3.47768 20.5C3.47768 11.1011 11.1011 3.47768 20.5 3.47768C29.8989 3.47768 37.5223 11.1011 37.5223 20.5C37.5223 29.8989 29.8989 37.5223 20.5 37.5223Z",
    fill: "#2A304A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.2edaca23042bcbe5c12ac339c2280803.svg";
export { ForwardRef as ReactComponent };